import Head from 'next/head';
import { useMemo, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useCustomerAuth } from '@backpackjs/storefront';
import { useCustomerTagFiltering } from '@hooks';
import { ProductComponent } from './ProductComponent';

export function ProductTemplate({ product, renderSections }) {
  const isProductHidden = useMemo(() => {
    return product?.tags?.includes('hide-from-search');
  }, [product?.tags]);
  const { customerInit } = useCustomerAuth();
  const router = useRouter();
  const { customerFilterTags, customerTags } = useCustomerTagFiltering();

  const isRestrictedProduct = useMemo(() => {
    if (!product?.tags?.length || !customerFilterTags?.length) return false;
    return (
      customerInit &&
      !!product?.tags?.find(
        (tag) =>
          customerFilterTags?.includes(tag) && !customerTags?.includes(tag)
      )
    );
  }, [product?.tags, customerFilterTags, customerInit, customerTags]);

  useEffect(() => {
    if (isRestrictedProduct && customerInit) {
      router.push('/');
    }
  }, [isRestrictedProduct, router, customerInit]);

  if (isRestrictedProduct) {
    return null;
  }

  return (
    <>
      {isProductHidden ? (
        <Head>
          <meta
            name="robots"
            key="default-all-search-engines-crawling"
            content="noindex"
          />
          <meta
            name="googlebot"
            key="default-google-engine-crawling"
            content="noindex"
          />
        </Head>
      ) : null}
      <ProductComponent product={product} sections={renderSections()} />
    </>
  );
}

ProductTemplate.displayName = 'ProductTemplate';
